import React from "react";
var __jsx = React.createElement;
import MoreButtonSVG from "../../../../SVGs/MoreButtonSVG";
import stl from "./List.module.css";
import Button from "@/components/UiKit/Button/Button";
import useHelpers from "@hooks/useHelpers";
var List = function List(_ref) {
  var title = _ref.title,
    list = _ref.list,
    inLineButtonText = _ref.inLineButtonText,
    buttonText = _ref.buttonText,
    buttonUrl = _ref.buttonUrl,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateToHard = _useHelpers.navigateToHard;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.CL_container, " ").concat(className)
  }, /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement("div", {
    className: stl.CL_list
  }, list.map(function (city, idx) {
    return /*#__PURE__*/React.createElement("a", {
      key: idx,
      href: createUrl("/city/".concat(city.seo_name))
    }, /*#__PURE__*/React.createElement("h3", null, city.name));
  }), inLineButtonText && /*#__PURE__*/React.createElement("a", {
    href: createUrl(buttonUrl)
  }, /*#__PURE__*/React.createElement("h3", null, inLineButtonText, /*#__PURE__*/React.createElement(MoreButtonSVG, null)))), buttonText && /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      navigateToHard(buttonUrl);
    },
    className: stl.partnersButton
  }, buttonText));
};
export default List;